import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { useToast } from '../ui/use-toast';
import { Requester } from '@/lib/Requester';
import { MasterpassTokenResponse } from '@/models/Order';
import { GenericResponse } from '@/models/GenericResponse';
import { Endpoints } from '@/lib/Endpoints';
import MasterpassCardForm from './MasterpassCardForm';
import Image from 'next/image';
import SmartImage from '../SmartImage';

export default function MasterpassAddCardDialog({
  open,
  onOpenChange,
  fullnamePreset,
  addingCard,
  setAddingCard,
  mfsResponseHandler,
  setPaying,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fullnamePreset: string;
  addingCard: boolean;
  setAddingCard: (open: boolean) => void;
  mfsResponseHandler: (status, response) => void;
  setPaying: (loading: boolean) => void;
}) {
  const { toast } = useToast();

  const aError = () => {
    toast({
      variant: 'destructive',
      description: 'Bir hata oluştu',
    });
  };

  const onSubmit = async (values: any) => {
    // z.infer<typeof FormSchema>
    if (addingCard) {
      return;
    }
    if (!window?.Masterpass) {
      aError();
      return;
    }
    setAddingCard(true);
    const { data: result } = await Requester.get<GenericResponse<MasterpassTokenResponse>>(
      Endpoints.MASTERPASS_GET_TOKEN,
    );
    if (!result?.data?.accessToken || !result?.data?.serviceUrl) {
      aError();
      return;
    }
    const serviceData = result?.data;
    window.Masterpass.setEndpoint(serviceData.serviceUrl);
    window.Masterpass.setToken(serviceData.accessToken);
    const tokenData = window.Utils.decodeJwt(serviceData.accessToken);
    window.Masterpass.setMerchantId(tokenData.MerchantId);
    const referenceNumber = Date.now();
    const paylod = {
      accountKey: tokenData.AccountKey,
      accountKeyType: 'Msisdn',
      userId: tokenData.UserId,
      requestReferenceNumber: referenceNumber,
      terminalGroupId: tokenData.terminalGroupId,
      cardNumber: values.cardNumber,
      expiryDate: `${values.expirationYear}${values.expirationMonth}`,
      accountAliasName: values.cardAlias || 'Kredi Kartı',
      cardHolderName: values.fullname,
      cvv: values.cvv,
    };
    window.Masterpass.accountService.addCard(paylod, mfsResponseHandler);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="space-y-0">
          <div className="mb-5 text-center">
            <SmartImage
              className="inline"
              src="/masterpass.svg"
              alt="masterpass by mastercard"
              width={149}
              height={32}
              imageType="custom"
            />
          </div>
          <DialogTitle className="text-[32px] text-hzc_purple_500">Kart Ekle</DialogTitle>
          <DialogDescription className="h-0"></DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <MasterpassCardForm
            addingCard={addingCard}
            fullnamePreset={fullnamePreset}
            onOpenChange={onOpenChange}
            onSubmit={onSubmit}
            open={open}
            forPayment={false}
            userIsAnonymous={false}
            setPaying={setPaying}
          />
        </div>
        <DialogFooter className="block text-sm">
          Kart bilgileriniz Mastercard’ın dijital ödeme altyapısı olan{' '}
          <a
            className="text-[#01B0EF]"
            href="https://www.mastercard.com.tr/tr-tr/tuketiciler/odeme-secenekleri/masterpass.html"
            target="_blank"
          >
            Masterpass
          </a>
          ’te güvenle saklanmaktadır.
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
